import { hide, toggle } from 'slidetoggle';
import Sortable from 'sortablejs';
import  {filterInputNumber} from "./validate-form";

const floorNode = document.querySelector( '#realpress_floor_plan_content' );
const innerPanel = floorNode.querySelector( '.realpress-field-panel-inner' );
let fieldPanelNodes = innerPanel.querySelectorAll( '.realpress-field-panel:not(.realpress-field-panel-template)' );
let fieldPanelNumber = fieldPanelNodes.length;
const changeableAtrealpress = [ 'id', 'name', 'for' ];
const { __ } = wp.i18n;

const realpressFloor = () => {
	const fieldPanelTempNode = innerPanel.querySelector( '.realpress-field-panel-template' );
	fieldPanelTempNode.remove();
	floorNode.querySelector( '.add-more' ).addEventListener( 'click', function() {
		const clonePanelNode = fieldPanelTempNode.cloneNode( true );
		changeAttributes( clonePanelNode );
		innerPanel.appendChild( clonePanelNode );
		fieldPanelNumber = fieldPanelNumber + 1;
	} );

	for ( let i = 0; i < fieldPanelNodes.length; i++ ) {
		//First panel is opend, the other is closed
		if ( i !== 0 ) {
			hide( fieldPanelNodes[ i ].querySelector( '.realpress-field-panel-content' ), {} );
			fieldPanelNodes[ i ].querySelector( '.realpress-button-toggle i' ).className = 'dashicons dashicons-plus-alt2';
		}
		handlePanelElements( fieldPanelNodes[ i ] );
	}

	// Drag and drop
	Sortable.create( innerPanel, {
		handle: '.realpress-field-panel-title', animation: 150,
		onEnd() {
			reindexElements();
		},
	} );
};

const togglePanel = ( panelNode ) => {
	const iconNode = panelNode.querySelector( '.realpress-button-toggle i' );
	toggle(
		panelNode.closest( '.realpress-field-panel' ).querySelector( '.realpress-field-panel-content' ),
		{
			miliseconds: 300,
			onOpen: () => {
				iconNode.className = 'dashicons dashicons-minus';
			},
			onClose: () => {
				iconNode.className = 'dashicons dashicons-plus-alt2';
			},
			elementDisplayStyle: 'flex',
		}
	);
};

const reindexElements = () => {
	//Get update again NodeList
	fieldPanelNodes = floorNode.querySelectorAll( '.realpress-field-panel' );

	fieldPanelNodes.forEach( function( fieldPanelNode, index ) {
		fieldPanelNode.querySelectorAll( 'input,textarea,label' ).forEach( function( elementNode ) {
			for ( let i = 0; i < changeableAtrealpress.length; i++ ) {
				if ( elementNode.getAttribute( changeableAtrealpress[ i ] ) ) {
					elementNode.setAttribute( changeableAtrealpress[ i ],
						elementNode.getAttribute( changeableAtrealpress[ i ] ).replace( /(\d+)/, function( $el1, $el2 ) {
							return Number( index );
						} ) );
				}
			}
		} );
	} );
};

const handlePanelElements = ( panelNode ) => {
	// panelNode.querySelector( '.realpress-button-toggle' ).addEventListener( 'click', function() {
	// 	togglePanel( panelNode );
	// } );
	const inputNumberNodes = panelNode.querySelectorAll('.realpress-input-content input[type="number"]');
	filterInputNumber(inputNumberNodes);

	panelNode.querySelector( '.realpress-field-panel-title' ).addEventListener( 'click', function() {
		togglePanel( panelNode );
	} );

	panelNode.querySelector( '.realpress-button-remove' ).addEventListener( 'click', function() {
		this.closest( '.realpress-field-panel' ).remove();
		fieldPanelNumber = fieldPanelNumber - 1;
		reindexElements();
	} );

	panelNode.querySelector( '.realpress-input-wrapper input' ).addEventListener( 'keyup', function() {
		this.closest( '.realpress-field-panel' ).querySelector( '.realpress-field-panel-title-text' ).innerHTML = this.value;
	} );
};
const changeAttributes = ( clonePanelNode ) => {
	clonePanelNode.classList.remove( 'realpress-field-panel-template' );
	clonePanelNode.querySelectorAll( 'input,textarea,label' ).forEach( function( elementNode, index ) {
		const planTitle = __( 'New Plan Title', 'realpress' );
		clonePanelNode.querySelector( '.realpress-field-panel-title-text' ).innerHTML = planTitle;
		if ( index === 1 ) {
			elementNode.value = planTitle;
		}
		if ( elementNode.tagName === 'TEXTAREA' ) {
			elementNode.innerHTML = '';
		} else if ( elementNode.getAttribute( 'value' ) ) {
			elementNode.removeAttribute( 'value' );
		}

		for ( let i = 0; i < changeableAtrealpress.length; i++ ) {
			if ( elementNode.getAttribute( changeableAtrealpress[ i ] ) ) {
				elementNode.setAttribute( changeableAtrealpress[ i ],
					elementNode.getAttribute( changeableAtrealpress[ i ] ).replace( /(\d+)/, function( $el1, $el2 ) {
						if ( fieldPanelNumber ) {
							return fieldPanelNumber;
						}

						return 0;
					} ) );
			}
		}
	} );

	handlePanelElements( clonePanelNode );
};

export default realpressFloor;
